export default __webpack_public_path__ + "static/media/2.57efcf99.JPG";